export default __webpack_public_path__ + "static/media/ZettiBrandLogo.3c304aeb.svg";